<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-divider>
      <span class="pink">Image</span>
    </el-divider>
    <el-form-item
      label="Date Time"
      prop="date_time"
      :rules="stringRule('date_time')"
    >
      <el-date-picker
        v-model="item.date_time"
        type="datetime"
        placeholder="Choose Date Time"
        style="width: 100%;"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label="Size" prop="size" :rules="stringRule('size')">
      <el-select v-model="item.size">
        <el-option
          v-for="option in size_option"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="Top layer Image"
      prop="top_layer_image_url"
      :rules="[
        ...imageSizeRule({
          width: checkImgWidth,
          height: checkImgHeight,
        }),
        ...urlRule('image_url'),
      ]"
    >
      <file-input
        accept="image/jpeg, image/png, image/gif"
        v-model="item.top_layer_image_url"
        :check_upload_image_size="{
          width: checkImgWidth,
          height: checkImgHeight,
          enable: true,
        }"
      ></file-input>
    </el-form-item>
    <div
      v-for="(item, index) in item.images"
      :key="index"
      style="display: flex;"
    >
      <span
        style="height:40px; line-height: 40px; font-weight: bold; margin-right:4px;"
      >
        {{ index + 1 }}.
      </span>
      <el-form-item
        label="Image"
        :prop="`images.${index}.image_url`"
        :rules="[
          ...imageSizeRule({
            width: checkImgWidth,
            height: checkImgHeight,
          }),
          ...urlRule('image_url'),
        ]"
        label-width="144px"
        style="width:100%;"
      >
        <file-input
          accept="image/jpeg, image/png, image/gif"
          v-model="item.image_url"
          :check_upload_image_size="{
            width: checkImgWidth,
            height: checkImgHeight,
            enable: true,
          }"
        >
        </file-input>
      </el-form-item>
    </div>
    <div class="countdown_ultimate">
      <div class="countdown_ultimate-title">
        Time's Up Settings
      </div>
      <div class="countdown_ultimate-description">
        The following image will be displayed if the countdown timer expired.
      </div>
      <el-form-item
        label="Image"
        prop="ultimate_image_url"
        :rules="[
          ...imageSizeRule({
            width: checkImgWidth,
            height: checkImgHeight,
          }),
          ...urlRule('image_url'),
        ]"
      >
        <file-input
          accept="image/jpeg, image/png, image/gif"
          v-model="item.ultimate_image_url"
          :check_upload_image_size="{
            width: checkImgWidth,
            height: checkImgHeight,
            enable: true,
          }"
        ></file-input>
      </el-form-item>
      <el-form-item
        label="Landing Page"
        prop="ultimate_landing_page"
        :rules="urlRule('landing_page')"
      >
        <el-input v-model="item.ultimate_landing_page"></el-input>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
import formItemGroup from "../formItemGroup.vue";
const { COUNT_DOWN } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  components: { formItemGroup },
  data() {
    return {
      item: {
        images: [...Array(COUNT_DOWN.MIN_NUM)].map(() =>
          _.cloneDeep(COUNT_DOWN.ITEM)
        ),
        top_layer_image_url: "",
        date_time: "",
        size: "",
        ultimate_image_url: "",
        ultimate_landing_page: "",
      },
      size_option: [
        {
          label: "300 x 250",
          value: "300*250",
        },
        { label: "320 x 480", value: "320*480" },
      ],
    };
  },
  computed: {
    checkImgWidth() {
      return {
        max: parseInt(this.item.size.split("*")[0]),
        min: parseInt(this.item.size.split("*")[0]),
      };
    },
    checkImgHeight() {
      return {
        max: parseInt(this.item.size.split("*")[1]),
        min: parseInt(this.item.size.split("*")[1]),
      };
    },
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.date_time = row.date_time;
      this.item.size = `${row.width}*${row.height}`;
      this.item.top_layer_image_url = decodeURI(row.top_layer_image_url);
      this.item.ultimate_image_url = decodeURI(row.ultimate_image_url);
      this.item.ultimate_landing_page = decodeURI(row.ultimate_landing_page);
      this.item.images = _.map(row.images, (image) => {
        return {
          image_url: decodeURI(image.image_url),
        };
      });
    },
    async getData(setObj) {
      setObj.images = _.map(this.item.images, (image) => {
        return {
          image_url: image.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });
      setObj.top_layer_image_url = this.item.top_layer_image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      setObj.ultimate_landing_page = this.item.ultimate_landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      setObj.ultimate_image_url = this.item.ultimate_image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      setObj.date_time = this.item.date_time;
      setObj.width = parseInt(this.item.size.split("*")[0]);
      setObj.height = parseInt(this.item.size.split("*")[1]);
      return setObj;
    },
  },
};
</script>

<style lang="sass" scoped>
.countdown_ultimate
  background-color: #F5F5F5
  border-radius: 5px
  padding: 12px
  width: calc(100% + 24px)
  margin-left: -12px
  &-title
    font-weight: bold
    font-szie: 14px
  &-description
    color: #A8A8A8
    font-size: 12px
    margin-top: 4px
    margin-bottom: 16px
</style>
